export const CHAT_CONFIG = {
  modelId: 'anthropic.claude-sonnet-4-20250514',
  maxTokens: 4096,
  maxMessageLength: 2000,
  maxHistoryPairs: 50,
  maxRetries: 3,
  retryBaseDelay: 1000,
  requestTimeout: 30000,
  maxToolRounds: 5,
  region: 'us-east-1',
} as const;
